import toast from "react-hot-toast";
import { supabase } from ".";

export const getFacturasComisionTodos = async ({ edificios, fechas, pais }) => {
  try {
    const [fechaInicio, fechaFin] = fechas;

    const data = await supabase.select("sales", {
      filters: {
        pais: pais,
        facturafecha: {
          gte: fechaInicio,
          lte: fechaFin,
        },
        eliminada: !true,
      },
    });

    if (!data || data.length === 0) {
      toast.error("No hay facturas asociadas a los edificios en las fechas seleccionadas");
      return [];
    }

    // Filtrado manual de fechas
    const filteredByDate = data.filter((sale) => {
      // Excluir registros con facturafecha nula, vacía o no válida
      if (
        !sale.facturafecha ||
        sale.facturafecha === null ||
        sale.facturafecha === undefined ||
        sale.facturafecha === "" ||
        (typeof sale.facturafecha === "string" && sale.facturafecha.trim() === "")
      ) {
        return false;
      }

      const facturaFecha = new Date(sale.facturafecha);
      const isValidDate = !isNaN(facturaFecha.getTime());
      if (!isValidDate) {
        return false;
      }

      const fechaInicioDate = new Date(fechaInicio);
      const fechaFinDate = new Date(fechaFin);
      return facturaFecha >= fechaInicioDate && facturaFecha <= fechaFinDate;
    });

    // Filtrado manual para coincidencias exactas de IDs
    const filteredData = filteredByDate.filter((sale) => {
      const edificiosList = sale.edificiosparticipantes
        ? sale.edificiosparticipantes.split(",").map((id) => id.trim())
        : [];
      const edificiosStr = edificios.map(String);
      return edificiosList.some((id) => {
        const idStr = String(id).trim();
        return edificiosStr.includes(idStr);
      });
    });

    if (filteredData.length === 0) {
      toast.error("No se encontraron facturas válidas para los edificios seleccionados");
      return [];
    }

    return filteredData;
  } catch (error) {
    toast.error(`Error al obtener facturas: ${error.message}`);
    return [];
  }
};
